import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";
import {appendFormData} from "@/helpers/form";

export const certificationApi = createApi({
    reducerPath: 'certificationApi',
    tagTypes: ['certification'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getCertifications: build.query({
            query: (data) => ({
                url: api.certification.getCertifications(),
                method: 'GET',
                params: data
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                return [endpointName, ...(queryArgs?.location_ids ?? [])];
            },
            merge: (currentCache, newItems, {arg}) => {
                if (arg.skip === 0) {
                    return [...newItems];
                }
                return [
                    ...currentCache,
                    ...newItems.filter(
                        (newItem) => !currentCache.some((item) => item.uid === newItem.uid)
                    ),
                ];
            },
            forceRefetch: ({currentArg, previousArg}) => {
                return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
            },
            transformResponse: (response) => {
                return response.map((item) => ({
                    id: item.id,
                    uid: item.certificationFile[0].file.id,
                    name: item.name,
                    date: item.date,
                    status: 'done',
                    url: item.certificationFile[0].file.path,
                }));
            },
            providesTags: ['certification'],
        }),
        createCertification: build.mutation({
            query: ({...data}) => {
                const formData = new FormData();
                appendFormData(formData, data);

                return {
                    url: api.certification.createCertification(),
                    method: 'POST',
                    headers: {
                        'Content-Type': 'multipart/form-data;'
                    },
                    body: formData,
                    formData: true
                };
            },
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    const {data} = await queryFulfilled
                    dispatch(
                        certificationApi.util.updateQueryData('getCertifications', {certificationable_id: [patch.certificationable_id]}, (draft) => {
                            let newCertifications = [];
                            newCertifications.push({
                                id: data.id,
                                uid: data.certificationFile[0].file.id,
                                name: data.name,
                                date: data.date,
                                status: 'done',
                                url: data.certificationFile[0].file.path,
                            });
                            if (newCertifications.length > 0) {
                                draft.unshift(...newCertifications.reverse());
                            }
                        })
                    );
                } catch (e) {
                    console.error('Certification failed:', e)
                }
            },
        }),
        deleteCertification: build.mutation({
            query: ({id, ...data}) => ({
                url: api.certification.deleteCertification(id),
                method: 'DELETE',
                body: data
            }),
            async onQueryStarted(patch, {dispatch, queryFulfilled}) {
                try {
                    await queryFulfilled
                    dispatch(
                        certificationApi.util.updateQueryData('getCertifications', patch, (draft) => {
                            const index = draft?.findIndex((certification) => certification.id === patch.id);
                            if (index !== -1) {
                                draft.splice(index, 1)
                            }
                        })
                    );
                } catch (e) {
                    console.error('Certification failed:', e)
                }
            },
        }),
    })
})

export const {
    useLazyGetCertificationsQuery,
    useCreateCertificationMutation,
    useDeleteCertificationMutation
} = certificationApi